import type { AppRouteRecordRaw } from '@/router/types'
import { useI18n } from '@/hooks/web/useI18n'
import { LAYOUT, BLANK } from '@/router/constant'

const { t } = useI18n()

const AccessPermissionManagement_ROUTES: AppRouteRecordRaw[] = [
  {
    path: '/AccessPermissionManagement',
    name: 'AccessPermissionManagement',
    component: LAYOUT,
    meta: {
      title: t('router.accessPermissionManagement'),
      hideBreadcrumb: true,
      hideMenu: false,
      icon: 'creditcard',
      perCode: 'ACCESS_PERMISSION_MANAGEMENT'
    },
    children: [
      {
        path: 'ic-card-user-manager',
        name: 'IC-card-user-manager',
        component: BLANK,
        redirect: '/AccessPermissionManagement/ic-card-user-manager/index',
        meta: {
          title: t('router.ICCardUserManagement'),
          hideBreadcrumb: true,
          master: true,
          hideMenu: false,
          perCode: 'kedex:access:manage'
        },
        children: [
          {
            path: 'index',
            name: 'ICCardUserManagerIndex',
            component: () => import('@/views/icCardManagement/index.vue'),
            meta: {
              title: t('icCard.makeCard'),
              hideBreadcrumb: true,
              hideMenu: false,
              layout: 'adaptive-height'
            }
          },
          {
            path: 'make-card',
            name: 'MakeCard',
            component: () => import('@/views/icCardManagement/make-card/index.vue'),
            meta: {
              title: t('icCard.makeCard'),
              hideBreadcrumb: true,
              master: true,
              hideMenu: false,
              perCode: 'kedex:access:manage:make'
            }
          },
          {
            path: 'card-info',
            name: 'CardInfo',
            component: () => import('@/views/icCardManagement/make-card/card-info.vue'),
            meta: {
              title: t('icCard.makeCard'),
              hideBreadcrumb: true,
              hideMenu: true
            }
          },
          {
            path: 'delay-card',
            name: 'DelayCard',
            component: () => import('@/views/icCardManagement/delay-card/index.vue'),
            meta: {
              title: t('icCard.delayCard'),
              hideBreadcrumb: true,
              hideMenu: false,
              master: true,
              perCode: 'kedex:access:manage:recharge'
            }
          },
          {
            path: 'manager-card',
            name: 'ManagerCardList',
            component: () => import('@/views/icCardManagement/manager-card/index.vue'),
            meta: {
              title: t('icCard.managerCardList'),
              hideBreadcrumb: true,
              hideMenu: false,
              master: true,
              perCode: 'kedex:access:manage:list'
            }
          },
          {
            path: 'card-replace',
            name: 'ReplaceCard',
            component: () => import('@/views/icCardManagement/make-card/card-replacement.vue'),
            meta: {
              title: t('router.cardReplace'),
              hideBreadcrumb: true,
              hideMenu: false
            }
          },
          {
            path: 'update-card',
            name: 'update-card',
            component: () => import('@/views/icCardManagement/make-card/update-card.vue'),
            meta: {
              title: t('router.updateCard'),
              hideBreadcrumb: true,
              hideMenu: true
            }
          },
          {
            path: 'admin-card-info',
            name: 'AdminCardInfo',
            component: () => import('@/views/icCardManagement/make-card/admin-card-info.vue'),
            meta: {
              title: t('icCard.makeCard'),
              hideBreadcrumb: true,
              hideMenu: true
            }
          }
        ]
      },
      {
        path: 'phone-user-manage',
        name: 'phoneUserManager',
        component: BLANK,
        redirect: '/AccessPermissionManagement/phone-user-manage/index',
        meta: {
          title: t('router.phoneUserManage'),
          perCode: 'WECHAT_CALL_MANAGEMENT'
        },
        children: [
          {
            path: 'index',
            name: 'phoneUserManagerIndex',
            //手机用户管理
            component: () => import('@/layouts/microApp/index.vue'),
            meta: {
              title: t('router.phoneUserManage'),
              microUrl: '/kol/index.html#/kol/callElevator',
              path: '/#/kol/callElevator'
            }
          }
        ]
      },
      {
        path: 'phone-user-manage-intro',
        name: 'phoneUserManagerIntro',
        component: BLANK,
        redirect: '/AccessPermissionManagement/phone-user-manage-intro/index',
        meta: {
          title: t('router.phoneUserManage'),
          perCode: 'kol:phoneCallElevatorIntro'
        },
        children: [
          {
            path: 'index',
            name: 'phoneUserManagerIntroIndex',
            //手机用户管理
            component: () => import('@/views/koneOnline/todo.vue'),
            meta: {
              title: t('router.phoneUserManage'),
              master: true
            }
          }
        ]
      }
    ]
  }
]

export default AccessPermissionManagement_ROUTES
